var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"is-clickable has-text-grey-dark resetBtn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('reset')}}},[_vm._v("X")])}
var staticRenderFns = []

export { render, staticRenderFns }